import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/resizable.css';
import 'jquery-ui/themes/base/draggable.css';

import UIElement from './UIElement';
import DesktopManager from './DesktopManager';

export default class WindowFrame extends UIElement {
  public static readonly Selector: string = '.window-frame';

  public readonly desktopManager: DesktopManager;

  public constructor(element: HTMLElement, desktopManager: DesktopManager) {
    super(element);
    this.desktopManager = desktopManager;
  }

  public override mount() {
    this.$element.resizable({
      handles: {
        n: this.$element.find('.border-container > .edge.top'),
        e: this.$element.find('.border-container > .edge.right'),
        s: this.$element.find('.border-container > .edge.bottom'),
        w: this.$element.find('.border-container > .edge.left'),
        ne: this.$element.find('.border-container > .corner.right-top'),
        se: this.$element.find('.border-container > .corner.right-bottom'),
        sw: this.$element.find('.border-container > .corner.left-bottom'),
        nw: this.$element.find('.border-container > .corner.left-top'),
      },
    });

    this.$element.draggable({
      handle: '.title-bar-text',
      scroll: true,
      zIndex: 1000,
      drag: (_, ui) => {
        this.onDrag(ui);
      },
    });

    this.$element
      .find('.title-bar-button.close-button')
      .on('click', this.onCloseButtonClick.bind(this));
  }

  public close() {
    this.$element
      .css('top', '')
      .css('left', '')
      .css('z-index', '')
      .css('display', 'none');
  }

  // noinspection JSDeprecatedSymbols
  private onDrag(ui: JQueryUI.DraggableEventUIParams) {
    const objectHeight: number = this.$element.outerHeight() || 0;
    const objectWidth: number = this.$element.outerWidth() || 0;
    const objectBottom: number = ui.offset.top + objectHeight;
    const objectRight: number = ui.offset.left + objectWidth;
    const bounds = this.desktopManager.checkAndAdjustBounds(
      objectRight,
      objectBottom,
    );

    if (ui.offset.top < 0) {
      ui.position.top += -ui.offset.top;
    }

    if (ui.offset.left < 0) {
      ui.position.left += -ui.offset.left;
    }

    if (objectBottom > bounds.height) {
      ui.position.top -= objectBottom - bounds.height;
    }

    if (objectRight > bounds.width) {
      ui.position.left -= objectRight - bounds.width;
    }
  }

  private onCloseButtonClick(ev: JQuery.ClickEvent) {
    this.close();
    ev.stopPropagation();
  }
}
